export function getAdditionParameterListFromQueryParameterList(queryParameters: any) {
    const additionalParams: any[] = []

    if (queryParameters?.pagination) {
        const skip: number = queryParameters.pagination.page * queryParameters.pagination.pageSize;
        const take: number = queryParameters.pagination.pageSize;

        additionalParams.push({
            name: 'skip',
            value: skip
        });

        additionalParams.push({
            name: 'take',
            value: take
        });
    }

    if (queryParameters?.sorting !== undefined
        && queryParameters.sorting.orderField !== undefined
        && queryParameters.sorting.sortOrder !== undefined) {
        additionalParams.push({
            name: 'orderField',
            value: queryParameters?.sorting.orderField
        });

        additionalParams.push({
            name: 'sortOrder',
            value: queryParameters?.sorting.sortOrder
        });
    }

    if (queryParameters?.checkin !== undefined) {
        additionalParams.push({
            name: 'checkin',
            value: queryParameters?.checkin
        });
    }

    if (queryParameters?.locationsIds !== undefined){
        additionalParams.push({
            name: 'locationsIds',
            value: queryParameters.locationsIds
        })
    }

    if (queryParameters?.locationId !== undefined){
        additionalParams.push({
            name: 'locationId',
            value: queryParameters.locationId
        })
    }  

    //
    if (queryParameters?.bedrooms !== undefined) {
        //if (queryParameters.bedrooms.length === 0) {
        //    additionalParams.push({
        //        name: 'bedrooms',
        //        value: [0]
        //    })
        //}

        if (queryParameters?.bedrooms.length === 1) {
            const bedrooms = queryParameters.bedrooms[0]

            if (bedrooms.toLowerCase() === 'any') {
                
            } else if (bedrooms.includes('+')) {
                let bedroomsValue = (parseInt(bedrooms)) - 1
                additionalParams.push({
                    name: 'bedrooms',
                    value: Array.from(Array(20), (e, i) => i + 1 + bedroomsValue)
                })
            } else {
                additionalParams.push({
                    name: 'bedrooms',
                    value: Array.from([parseInt(bedrooms)])
                })
            }
        }
    }
    //

    if (queryParameters?.beds !== undefined) {

        if (queryParameters.beds.length === 1) {
            const beds = queryParameters.beds[0]

            if (beds.toLowerCase() === 'any') {

            } else if (beds.includes('+')) {
                let bedsValue = (parseInt(beds)) - 1
                additionalParams.push({
                    name: 'beds',
                    value: Array.from(Array(20), (e, i) => i + 1 + bedsValue)
                })
            } else {
                additionalParams.push({
                    name: 'beds',
                    value: Array.from([parseInt(beds)])
                })
            }
        }
    }

    //
    if (queryParameters?.pets !== undefined) {
        if (queryParameters.pets.length === 1) {
            const pets = queryParameters.pets[0]

            if (Number.isInteger(pets)){
                additionalParams.push(
                    {
                        name: 'pets',
                        value: Array.from([pets])
                    })
            } else if (pets.includes('+')) {
                let petsValue = (parseInt(pets)) - 1
                additionalParams.push({
                    name: 'pets',
                    value: Array.from(Array(20), (e, i) => i + 1 + petsValue)
                })
            } else {
                additionalParams.push({
                    name: 'pets',
                    value: Array.from([parseInt(pets)])
                })
            }
        }
    }



    return additionalParams
}